// extracted by mini-css-extract-plugin
export default {"hollow_dots_spinner":"style_hollow_dots_spinner__ud3pz","dot":"style_dot__buM5S","hollow_dots_spinner-animation":"style_hollow_dots_spinner-animation__vTi63"};